<template>
  <v-container>
    <div v-if="loadingView">
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>

      <v-skeleton-loader
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row>
        <v-col>
          <go-back-btn :routeToGo="routeToGo" />
          <PageHeader :title="title" class="mb-3" />
          <v-card-text class="px-0">
            <v-row>
              <v-col
                col="12"
                md="6"
                class="pt-0 pl-2 pr-0 pb-0"
                align="start"
                align-self="center"
              >
                <v-btn-toggle dense v-model="text" color="primary" group>
                  <v-btn value="DATOS GENERALES" @click="switchTab(1)">
                    Datos generales
                  </v-btn>
                  <v-btn
                    :disabled="!clientId"
                    @click="switchTab(2)"
                  >
                    Conexión
                  </v-btn>
                  <v-btn
                    :disabled="!clientId"
                    @click="switchTab(3)"
                  >
                    Configuración
                  </v-btn>
                  <v-btn
                    :disabled="!clientId"
                    @click="switchTab(4)"
                  >
                    Contactos
                  </v-btn>
                  <v-btn
                    :disabled="!clientId"
                    @click="switchTab(5)"
                  >
                    Versiones
                  </v-btn>
                  <v-btn
                    :disabled="!clientId"
                    @click="switchTab(8)"
                  >
                    Productos
                  </v-btn>
                  <v-btn
                    :disabled="!clientId"
                    @click="switchTab(6)"
                  >
                    Notas
                  </v-btn>
                  <v-btn
                    :disabled="!clientId"
                    @click="switchTab(7)"
                  >
                    Otros datos
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
            <!-- datos generales -->
            <v-row class="pt-2 pb-2">
              <v-col cols="1" class="py-0 pr-6">
                <v-text-field
                  v-model="clientId"
                  dense
                  label="Id"
                  outlined
                  class="center-input"
                  disabled
                  autocomplete="off"
                  filled
                  readonly
                  hide-details="true"
                >
                </v-text-field>
              </v-col>
              <v-col cols="4" class="py-0 pl-0">
                <v-text-field
                  v-model="clienteNombre"
                  dense
                  label="Nombre"
                  outlined
                  readonly
                  disabled
                  filled
                  hide-details="true"
                >
                </v-text-field>
              </v-col>
              <v-col cols="3" class="py-0">
                <v-text-field
                  v-model="fechaBajaSelected"
                  label="Fecha baja"
                  outlined
                  readonly
                  disabled
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="py-0">
                <v-autocomplete
                  v-model="provinciaSelected"
                  :items="provincias"
                  label="Provincia"
                  item-text="value"
                  item-value="id"
                  outlined
                  disabled
                  filled
                  dense
                  clearable
                  hide-details="true"
                ></v-autocomplete>
              </v-col>
              <v-col cols="2" class="py-0">
                <v-text-field
                  v-model="estado"
                  hide-details="true"
                  label="Estado"
                  outlined
                  solo
                  filled
                  readonly
                  :background-color="getEstadoColor(estado)"
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
            <section
              v-if="tabOptions && tabOptions.tabId == 1"
              class="pt-2 pl-0 pb-0"
            >
              <v-row class="py-0">
                <v-col cols="3" class="py-0">
                  <v-text-field
                    v-model="razonSocial"
                    hide-details="true"
                    label="Razon social"
                    outlined
                    disabled
                    filled
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="5" class="py-0">
                  <v-autocomplete
                    v-model="equipoSoporteSelected"
                    :items="equiposSoporte"
                    item-text="value"
                    item-value="id"
                    label="Equipo de soporte"
                    outlined
                    disabled
                    filled
                    hide-details="true"
                    autocomplete="off"
                    clearable
                    dense
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-text-field
                    v-model="fechaLicenciaSelected"
                    label="Fecha licencia"
                    outlined
                    dense
                    disabled
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="pt-0 pb-2">
                  <v-switch
                    class="mt-0 mb-0"
                    v-model="licenciaPerpetua"
                    dense
                    hide-details="true"
                    outlined
                    disabled
                    filled
                    label="Lic. sin corte"
                  >
                  </v-switch>
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col cols="12" class="py-0">
                  <v-textarea
                    v-model="observaciones"
                    label="Observaciones"
                    dense
                    hide-details="true"
                    auto-grow
                    rows="1"
                    readonly
                    outlined
                    filled
                  ></v-textarea>
                </v-col>
              </v-row>
            </section>
            <!-- Conexiones -->
            <section v-if="tabOptions.tabId == 2">
              <v-row class="pt-7">
                <v-col cols="12" md="12" class="py-0 mt-n2">
                  <v-data-table
                    class="elevation-2"
                    :headers="headersDatosAcceso"
                    :items="filterSoloActivosDatosAcceso"
                    dense
                    item-key="idDatos"
                    :loading="isLoadingDatosAcceso"
                    no-data-text="No hay datos disponibles para mostrar"
                    :hide-default-footer="
                      itemsDatosAcceso.length > 10 ? false : true
                    "
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-col cols="2" class="pl-0 pt-0" align="start">
                          <h4 class="primary--text">Datos de acceso</h4>
                        </v-col>
                        <v-col cols="10" class="py-0 my-0 pr-0">
                          <v-switch
                            class="mt-0"
                            v-model="soloActivosDatosAcceso"
                            label="Solo activos"
                            hide-details="true"
                            outlined
                          ></v-switch>
                        </v-col>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.habilitado`]="{ item }">
                      <v-icon v-if="item.habilitado" small color="primary">
                        {{ checkIcon }}
                      </v-icon>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            size="20"
                            v-on="on"
                            @click="verDatosAcceso(item)"
                          >
                            {{ seeIcon }}
                          </v-icon>
                        </template>
                        <span>Ver detalle</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row class="pt-3">
                <!-- Conexiones -->
                <v-col cols="12" md="12" class="py-0 mt-n2">
                  <v-data-table
                    class="elevation-2"
                    :headers="headersConexiones"
                    :items="filterSoloActivosConexiones"
                    dense
                    :loading="isLoadingConexiones"
                    item-key="id"
                    no-data-text="No hay datos disponibles para mostrar"
                    :hide-default-footer="
                      itemsConexiones.length > 10 ? false : true
                    "
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-col cols="2" align="start" class="pl-0 pt-0">
                          <h4 class="pl-0 primary--text">Conexiones RDP</h4>
                        </v-col>
                        <v-col cols="10" class="py-0 my-0 pr-0">
                          <v-switch
                            class="mt-0"
                            v-model="soloActivosConexiones"
                            label="Solo activos"
                            hide-details="true"
                            outlined
                          ></v-switch>
                        </v-col>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.habilitado`]="{ item }">
                      <v-icon v-if="item.habilitado" small color="primary">
                        {{ checkIcon }}
                      </v-icon>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            size="20"
                            v-on="on"
                            @click="editConexion(item)"
                          >
                            {{ seeIcon }}
                          </v-icon>
                        </template>
                        <span>Ver detalle</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </section>
            <!-- Configuracion -->
            <section v-if="tabOptions.tabId == 3">
              <v-row class="pt-6">
                <!-- Servidores -->
                <v-col cols="12" md="12" class="py-0 mt-n2">
                  <v-data-table
                    class="elevation-2"
                    :headers="headersServidores"
                    :items="itemsServidores"
                    dense
                    :expanded.sync="expandedServidores"
                    show-expand
                    item-key="servidoresClientesId"
                    no-data-text="No hay datos disponibles para mostrar"
                    :hide-default-footer="
                      itemsServidores.length > 10 ? false : true
                    "
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-col cols="6" class="pl-0 pt-0">
                          <h4 class="pl-0 primary--text">Servidores</h4>
                        </v-col>
                      </v-toolbar>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <strong>Fecha alta:</strong>
                        {{ item.fecAltaToShow }}
                        <strong style="padding-left: 80px"
                          >Usuario alta:</strong
                        >
                        {{ item.usuAlta }}
                        <strong style="padding-left: 80px"
                          >Fecha modificación:</strong
                        >
                        {{ item.fecModiToShow }}
                        <strong style="padding-left: 80px"
                          >Usuario modificación:</strong
                        >
                        {{ item.usuModi }}
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row class="pt-4">
                <!-- Sitios web -->
                <v-col cols="12" md="12" class="py-0 mt-n2">
                  <v-data-table
                    class="elevation-2 sitios-web-table"
                    :headers="headersSitios"
                    :items="filteredItemsSitios"
                    :search="searchSitios"
                    :custom-filter="filterSitios"
                    :expanded.sync="expandedSitios"
                    dense
                    item-key="sitioLocalId"
                    :item-class="getSitioRowClass"
                    no-data-text="No hay datos disponibles para mostrar"
                    :hide-default-footer="
                      filteredItemsSitios.length > 10 ? false : true
                    "
                    @click:row="toggleSitioExpanded"
                  >
                    <template v-slot:top>
                      <div class="sitios-table-toolbar">
                        <div class="sitios-table-header">
                          <h4 class="pl-0 primary--text mb-0">Sitios</h4>
                        </div>
                        <div class="sitios-filters">
                          <v-text-field
                            v-model="searchSitios"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                            dense
                            clearable
                            class="sitios-search"
                          ></v-text-field>
                          <v-autocomplete
                            v-model="sistemaSitiosSelected"
                            :items="itemsSistemas"
                            item-text="value"
                            item-value="id"
                            label="Sistema"
                            hide-details
                            dense
                            clearable
                            class="sitios-system-filter"
                          ></v-autocomplete>
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.sistemaNombre`]="{ item }">
                      <div class="sitio-main-cell">
                        <span
                          class="sitio-main-text"
                          v-html="
                            highlightSitioText(
                              item.sitioNombre || 'Sin sitio seleccionado'
                            )
                          "
                        ></span>
                        <span
                          class="sitio-secondary-text"
                          v-html="highlightSitioText(item.sistemaNombre || '-')"
                        ></span>
                      </div>
                    </template>
                    <template v-slot:[`item.descripcion`]="{ item }">
                      <span
                        v-html="highlightSitioText(item.descripcion || '-')"
                      ></span>
                    </template>
                    <template v-slot:[`item.habilitado`]="{ item }">
                      <div class="sitio-status-switch">
                        <v-switch
                          v-model="item.habilitado"
                          class="mt-0 pt-0"
                          dense
                          inset
                          readonly
                          hide-details="true"
                          @click.stop
                        />
                      </div>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="sitio-detail-row">
                        <div
                          v-if="getSitioDetailFields(item).length"
                          class="sitio-detail-table-wrap"
                        >
                          <table class="sitio-detail-table">
                            <thead>
                              <tr>
                                <th
                                  v-for="field in getSitioDetailFields(item)"
                                  :key="`header-${field.label}`"
                                >
                                  {{ field.label }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  v-for="field in getSitioDetailFields(item)"
                                  :key="`value-${field.label}`"
                                >
                                  <span
                                    v-if="field.sensitive"
                                    class="sitio-sensitive-value"
                                  >
                                    <span>
                                      {{
                                        isSitioCadenaVisible(item)
                                          ? field.value
                                          : getMaskedValue(field.value)
                                      }}
                                    </span>
                                    <v-icon
                                      v-if="canSeeSitioConnectionString"
                                      small
                                      color="grey darken-1"
                                      @click.stop="
                                        toggleSitioCadenaVisible(item)
                                      "
                                    >
                                      {{
                                        isSitioCadenaVisible(item)
                                          ? "mdi-eye-off"
                                          : "mdi-eye"
                                      }}
                                    </v-icon>
                                  </span>
                                  <span
                                    v-else
                                    v-html="highlightSitioText(field.value)"
                                  ></span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else class="sitio-detail-empty">
                          Sin datos adicionales cargados
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row class="pt-4">
                <v-col cols="12" class="py-0 mt-n2">
                  <v-card class="elevation-2">
                    <v-toolbar flat>
                      <v-col cols="12" class="pl-0 pt-0">
                        <h4 class="pl-0 primary--text">
                          Configuración de actualizaciones
                        </h4>
                      </v-col>
                    </v-toolbar>
                    <v-card-text class="pt-0 pb-3">
                      <v-text-field
                        v-model="rutaDescargaPaquetes"
                        label="Carpeta destino de descargas de paquetes"
                        outlined
                        dense
                        disabled
                        readonly
                        hide-details="auto"
                      ></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    class="elevation-2"
                    :headers="headersUsuariosBasicos"
                    :items="itemsUsuariosBasicos"
                    dense
                    item-key="clientexTipoIsId"
                    :hide-default-footer="
                      itemsUsuariosBasicos.length > 10 ? false : true
                    "
                    no-data-text="No hay datos disponibles para mostrar"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-row>
                          <v-col cols="10" class="pl-2 pt-2">
                            <h4 class="pl-0 primary--text">Usuarios básicos</h4>
                          </v-col>
                        </v-row>
                      </v-toolbar>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col
                  cols="12"
                  v-if="permisoAvanzado && canSeeUsuarioAvanzado"
                >
                  <v-data-table
                    class="elevation-2"
                    :headers="headersUsuariosAvanzados"
                    :items="itemsUsuariosAvanzados"
                    dense
                    item-key="clientexTipoIsId"
                    :hide-default-footer="
                      itemsUsuariosAvanzados.length > 10 ? false : true
                    "
                    no-data-text="No hay datos disponibles para mostrar"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-row>
                          <v-col cols="10" class="pl-2 pt-2">
                            <h4 class="pl-0 primary--text">
                              Usuarios avanzados
                            </h4>
                          </v-col>
                        </v-row>
                      </v-toolbar>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </section>
            <!-- Contactos -->
            <section v-if="tabOptions.tabId == 4">
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    class="elevation-2 mt-6"
                    :headers="headersContacto"
                    :items="itemsContacto"
                    item-key="contactoId"
                    :loading="isLoadingContactos"
                    no-data-text="No hay datos disponibles para mostrar"
                    :hide-default-footer="
                      itemsContacto.length > 10 ? false : true
                    "
                    dense
                  >
                    <template v-slot:[`item.esReferente`]="{ item }">
                      <v-icon v-if="item.esReferente" small color="primary">
                        {{ checkIcon }}
                      </v-icon>
                    </template>
                    <template v-slot:[`item.informarActualizacion`]="{ item }">
                      <v-icon
                        v-if="item.informarActualizacion"
                        small
                        color="primary"
                      >
                        {{ checkIcon }}
                      </v-icon>
                    </template>
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-row>
                          <v-col cols="10" class="pl-2 pt-2">
                            <h4 class="pl-0 primary--text">Contactos</h4>
                          </v-col>
                        </v-row>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            size="20"
                            v-on="on"
                            @click="editContacto(item)"
                          >
                            {{ seeIcon }}
                          </v-icon>
                        </template>
                        <span>Ver detalle</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </section>
            <!-- Versiones -->
            <section v-if="tabOptions.tabId == 5">
              <v-row>
                <v-col cols="3" class="py-0 pt-5 mb-n7">
                  <v-autocomplete
                    v-model="sistemaSelected"
                    :items="itemsSistemas"
                    item-text="value"
                    item-value="id"
                    outlined
                    clearable
                    return-object
                    dense
                    autocomplete="off"
                    label="Sistemas"
                    @change="getVersiones"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-data-table
                    :loading="loadingVersiones"
                    class="elevation-2 mt-6"
                    dense
                    :headers="headersVersiones"
                    :items="itemsVersiones"
                    :hide-default-footer="
                      itemsVersiones.length > 10 ? false : true
                    "
                    no-data-text="No hay datos disponibles para mostrar"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-if="canViewActualizacionesClientes"
                            v-bind="attrs"
                            size="20"
                            v-on="on"
                            @click="openActualizacionVersion(item)"
                          >
                            {{ historyIcon }}
                          </v-icon>
                        </template>
                        <span>Ver actualizacion</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </section>
            <!-- Productos -->
            <section v-if="tabOptions.tabId == 8">
              <v-data-table
                class="elevation-2 mt-6"
                :headers="headersProductos"
                :items="itemsProductos"
                :loading="isLoadingProductos"
                dense
                item-key="productoLocalId"
                no-data-text="No hay datos disponibles para mostrar"
                :hide-default-footer="itemsProductos.length > 10 ? false : true"
              >
                <template v-slot:[`item.codigo`]="{ item }">
                  <span>{{ getProductoDescripcion(item.codigo) }}</span>
                </template>
                <template v-slot:[`item.guid`]="{ item }">
                  <td class="producto-guid-cell">
                    <span class="producto-guid-text">{{ item.guid }}</span>
                  </td>
                </template>
                <template v-slot:[`item.implementado`]="{ item }">
                  <div class="producto-switch-cell">
                    <v-switch
                      v-model="item.implementado"
                      class="mt-0 mb-0"
                      dense
                      hide-details="true"
                      readonly
                    ></v-switch>
                  </div>
                </template>
                <template v-slot:[`item.ubic_id`]="{ item }">
                  <span>{{ item.ubic_id || "-" }}</span>
                </template>
              </v-data-table>
            </section>
            <!-- Notas -->
            <section v-if="tabOptions.tabId == 6">
              <v-data-table
                class="elevation-2 mt-6"
                :headers="headerNotas"
                :items="itemsNotas"
                dense
                item-key="notaId"
                no-data-text="No hay datos disponibles para mostrar"
                :hide-default-footer="itemsNotas.length > 10 ? false : true"
              >
              </v-data-table>
            </section>
            <!-- Otros datos -->
            <section v-if="tabOptions.tabId == 7">
              <v-row class="py-0">
                <v-col cols="12" class="py-0">
                  <v-textarea
                    v-model="otrosDatos.servidores"
                    label="Servidores"
                    dense
                    hide-details="true"
                    auto-grow
                    rows="1"
                    readonly
                    outlined
                    filled
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="otrosDatos.conexion"
                    label="Conexión"
                    dense
                    hide-details="true"
                    auto-grow
                    rows="1"
                    readonly
                    filled
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="otrosDatos.equipoImplementador"
                    label="Actualización a cargo de"
                    dense
                    hide-details="true"
                    auto-grow
                    rows="1"
                    readonly
                    filled
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="otrosDatos.infoSitios"
                    label="Información de sitios"
                    dense
                    hide-details="true"
                    auto-grow
                    rows="1"
                    readonly
                    filled
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>
            </section>
          </v-card-text>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-if="openEditDatoConexion"
      v-model="openEditDatoConexion"
      max-width="55%"
      persistent
      @keydown.esc="openEditDatoConexion = false"
    >
      <EditConexionRdp
        :registrosParams="itemConexion"
        :idReg="clientId"
        :isDetalle="true"
        @closeAndReload="closeConexiones($event)"
      >
      </EditConexionRdp>
    </v-dialog>
    <v-dialog
      v-if="openEditContactos"
      v-model="openEditContactos"
      max-width="55%"
      persistent
      @keydown.esc="openEditContactos = false"
          >
        <EditContactoCliente
          :clienteId="clientId"
          :contactoId="contactoId"
          :isDetalle="true"
          @closeAndReload="closeContactos($event)"
        >
        </EditContactoCliente>
      </v-dialog>
      <v-dialog
        v-if="openVerDatosAcceso"
        v-model="openVerDatosAcceso"
        max-width="55%"
        persistent
        @keydown.esc="openVerDatosAcceso = false"
      >
        <VerDatosAcceso
          :datosTexto="datosAccesoToView.datosTexto"
          :habilitado="datosAccesoToView.habilitado"
          @closeModal="closeVerDatosAcceso"
        >
        </VerDatosAcceso>
      </v-dialog>
      <v-dialog
        v-if="openActualizacionModal"
        v-model="openActualizacionModal"
        max-width="92%"
        persistent
        @keydown.esc="openActualizacionModal = false"
      >
        <ActualizacionVersionCliente
          :cliente-id="actualizacionVersionItem.clienteId"
          :version-id="actualizacionVersionItem.versionId"
          @close="openActualizacionModal = false"
        ></ActualizacionVersionCliente>
      </v-dialog>
    </v-container>
  </template>

<script>
import PageHeader from "@/components/ui/PageHeader.vue";
import { mapActions } from "vuex";
import enums from "@/utils/enums/index.js";
import { mask } from "vue-the-mask";
import GoBackBtn from "@/components/shared/GoBackBtn";
import EditConexionRdp from "@/views/EditConexionRdp.vue";
import EditContactoCliente from "../views/EditContactoCliente.vue";
import VerDatosAcceso from "@/views/VerDatosAcceso.vue";
import ActualizacionVersionCliente from "@/components/ActualizacionVersionCliente.vue";
import enumsAdmin from "@/utils/enums/modules/index.js";

export default {
  directives: { mask },
  components: {
    PageHeader,
    GoBackBtn,
    EditConexionRdp,
    EditContactoCliente,
    VerDatosAcceso,
    ActualizacionVersionCliente,
  },
  name: "SeeAllDataClient",
  async created() {
    // await this.$store.dispatch(
    //   "user/updateFrequencyByOptionCode",
    //   this.$route.params.parentOptionCode
    // );
    await this.setSelects();
    this.canSeeSitioConnectionString =
      await this.puedeVerCadenasConexionSitios();
    this.setPermisos();
    const sistemas = await this.sistemasTaxonomy();
    this.itemsSistemas = sistemas;
    if (this.clientId) await this.setDatosCliente();
    else this.loadingView = false;
    this.$store.dispatch("user/changeAppLoading", {
      status: false,
      text: "",
      opaque: false,
    });
  },
  computed: {
    filterSoloActivosConexiones() {
      if (this.soloActivosConexiones) {
        return this.itemsConexiones.filter((x) => x.habilitado === true);
      } else return this.itemsConexiones;
    },
    filterSoloActivosDatosAcceso() {
      if (this.soloActivosDatosAcceso) {
        return this.itemsDatosAcceso.filter((x) => x.habilitado === true);
      } else return this.itemsDatosAcceso;
    },
    itemsSitiosHabilitados() {
      return this.itemsSitios.filter((x) => x.habilitado !== false);
    },
    filteredItemsSitios() {
      if (!this.sistemaSitiosSelected) return this.itemsSitiosHabilitados;

      return this.itemsSitiosHabilitados.filter(
        (sitio) => `${sitio.sistemaId}` === `${this.sistemaSitiosSelected}`
      );
    },
    headersSitiosToShow() {
      const hasApplication = this.itemsSitiosHabilitados.some((x) =>
        this.isSitioApplication(x)
      );
      const hasIis = this.itemsSitiosHabilitados.some((x) =>
        this.isSitioIis(x)
      );
      const applicationColumns = ["carpetaBackup"];
      const iisColumns = ["nombreSitioIIS", "nombrePoolIIS", "puertoIIS"];

      return this.headersSitios.filter((header) => {
        if (!hasApplication && applicationColumns.includes(header.value))
          return false;
        if (!hasIis && iisColumns.includes(header.value)) return false;
        return true;
      });
    },
  },
  data() {
    const clientItem = this.$route.params.clientItem || {};
    return {
      routeToGo: "/clientes",
      title: clientItem.clienteId
        ? `Datos cliente: ${clientItem.clienteId} - ${clientItem.clienteNombre}`
        : "Datos cliente",
      text: "DATOS GENERALES",
      checkIcon: enums.icons.CHECK_OUTLINE,
      seeIcon: enums.icons.SEE,
      historyIcon: enums.icons.HISTORIC,
      clienteNombre: null,
      observaciones: null,
      sitiosSistema: [],
      equiposSoporte: [],
      equipoSoporteSelected: null,
      provincias: [],
      provinciaSelected: null,
      sinSoporte: false,
      licenciaPerpetua: false,
      estado: null,
      calendarIcon: "mdi-calendar",
      fechaLicencia: null,
      fechaLicenciaSelected: null,
      fechaBajaSelected: null,
      fechaBaja: null,
      soloActivosConexiones: true,
      soloActivosDatosAcceso: true,
      tabOptions: { tabId: 1, tabName: "DATOS GENERALES" },
      codigoEquipo: null,
      soporte: false,
      rutaDescargaPaquetes: "",
      itemsSitios: [],
      searchSitios: "",
      sistemaSitiosSelected: null,
      expandedSitios: [],
      visibleCadenaConexionSitios: [],
      itemsSistemas: [],
      sistemaSelected: null,
      itemConexion: {},
      openEditDatoConexion: false,
      razonSocial: "",
      openEditContactos: false,
      openVerDatosAcceso: false,
      datosAccesoToView: {
        datosTexto: "",
        habilitado: false
      },
      actualizacionVersionItem: {},
      openActualizacionModal: false,
      canViewActualizacionesClientes: false,
      clientId: clientItem.clienteId || null,
      itemsNotas: [],
      itemsProductos: [],
      productosContratadosOptions: enums.productosContratados,
      isLoadingProductos: false,
      headerNotas: [
        {
          text: "Tipo de nota",
          sortable: false,
          value: "tipoNota",
        },
        {
          text: "Título",
          sortable: false,
          value: "titulo",
        },
        {
          text: "Descripción",
          sortable: false,
          value: "descripcion",
        },
        {
          text: "Fecha",
          sortable: false,
          value: "fecha",
        },
        {
          text: "Usuario",
          sortable: false,
          value: "usuario",
        },
      ],
      headersProductos: [
        {
          text: "Producto",
          sortable: false,
          value: "codigo",
          class: "col-producto-codigo",
          cellClass: "col-producto-codigo",
        },
        {
          text: "GUID",
          sortable: false,
          value: "guid",
          class: "col-producto-guid",
          cellClass: "col-producto-guid",
        },
        {
          text: "Activo",
          sortable: false,
          value: "implementado",
          align: "center",
          class: "col-producto-activo",
          cellClass: "col-producto-activo",
        },
        {
          text: "Ubic. ID",
          sortable: false,
          value: "ubic_id",
          align: "center",
          class: "col-producto-ubicacion",
          cellClass: "col-producto-ubicacion",
        },
      ],
      headersVersiones: [
        {
          text: "Fecha actualización",
          sortable: false,
          value: "fechaActualizacion",
        },
        { text: "Sistema", sortable: false, value: "sistema" },
        { text: "Versión", sortable: false, value: "versionNombre" },
        { text: "Fecha versión", sortable: false, value: "fechaVersion" },
        { text: "Usuario", sortable: false, value: "usuario" },
      ],
      itemsVersiones: [],
      loadingVersiones: false,
      itemsUsuariosAvanzados: [],
      headersUsuariosAvanzados: [
        { text: "Nombre", sortable: false, value: "tipoId.value" },
        {
          text: "Detalle",
          align: "start",
          sortable: false,
          value: "credencial",
        },
      ],
      itemsUsuariosBasicos: [],
      itemsContacto: [],
      headersContacto: [
        {
          text: "Nombre",
          sortable: false,
          value: "contactoNombre",
        },
        {
          text: "Referente",
          sortable: false,
          align: "center",
          value: "esReferente",
        },
        {
          text: "Informar actualización",
          sortable: false,
          align: "center",
          value: "informarActualizacion",
        },
        {
          text: "Email",
          sortable: false,
          value: "email",
        },
        {
          text: "Teléfono",
          sortable: false,
          value: "telefono",
        },
        { text: "Acciones", value: "actions", sortable: false, align: "end" },
      ],
      headersUsuariosBasicos: [
        { text: "Nombre", sortable: false, value: "tipoId.value" },
        {
          text: "Detalle",
          align: "start",
          sortable: false,
          value: "credencial",
        },
      ],
      headersSitios: [
        {
          text: "Sitio / Sistema",
          sortable: false,
          value: "sistemaNombre",
          align: "start",
        },
        { text: "Descripción", sortable: false, value: "descripcion" },
        {
          text: "Habilitado",
          sortable: false,
          value: "habilitado",
          align: "center",
        },
      ],
      itemsServidores: [],
      expandedServidores: [],
      headersServidores: [
        {
          text: "Tipo de servidor",
          sortable: false,
          value: "servidorNombre",
          align: "start",
          width: "180px",
        },
        {
          text: "Descripción",
          sortable: false,
          value: "descripcion",
          align: "start",
        },
        {
          text: "IP",
          sortable: false,
          value: "servidorIp",
          align: "start",
          width: "130px",
        },
        {
          text: "",
          value: "data-table-expand",
          align: "center",
        },
      ],
      itemsDatosAcceso: [],
      headersDatosAcceso: [
        {
          text: "Descripción",
          sortable: false,
          value: "datosTexto",
          align: "left",
        },
        {
          text: "Activo",
          sortable: false,
          value: "habilitado",
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ],
      itemsConexiones: [],
      headersConexiones: [
        {
          text: "Conexión",
          sortable: false,
          value: "nombreConexion",
          align: "left",
        },
        {
          text: "IP o url",
          sortable: false,
          value: "datoIp",
          align: "left",
        },
        {
          text: "Usuario",
          sortable: false,
          value: "usuario",
          align: "left",
        },
        {
          text: "Dominio",
          sortable: false,
          value: "dominio",
          align: "left",
        },
        {
          text: "Puerto",
          sortable: false,
          value: "puerto",
          align: "left",
        },
        {
          text: "Activo",
          align: "center",
          sortable: false,
          value: "habilitado",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "end",
          order: 12,
        },
      ],
      loadingView: true,
      isLoadingDatosAcceso: false,
      isLoadingConexiones: false,
      isLoadingContactos: false,
      allowedActions: null,
      permisoAvanzado: false,
      canSeeSitioConnectionString: false,
      canSeeUsuarioAvanzado: false,
      otrosDatos: null,
    };
  },
  methods: {
    ...mapActions({
      getEquipos: "clientesData/equiposTaxonomy",
      getProvincias: "clientesData/provinciasTaxonomy",
      getAllClientData: "clientesData/getAllClientData",
      getVersionesBySistema: "clientesData/getVersionesBySistema",
      puedeVerCadenasConexionSitios:
        "clientesData/puedeVerCadenasConexionSitios",
      sistemasTaxonomy: "clientesData/sistemasTaxonomy",
      getUsers: "clientesData/getUsers",
      sitiosSistemasTaxonomy: "clientesData/sitiosSistemasTaxonomy",
      getProductosContratados: "clientesData/getProductosContratados",
      puedeVerActualizacionesClientes:
        "versiones/puedeVerActualizacionesClientes",
    }),
    getProductoDescripcion(codigo) {
      return (
        this.productosContratadosOptions.find((x) => x.codigo === codigo)
          ?.descripcion || codigo
      );
    },
    getProductoContratadoId(producto) {
      return producto.productosContratadosId || producto.ProductosContratadosId;
    },
    getProductoUbicId(producto) {
      return producto.ubic_id ?? producto.ubicId ?? producto.UbicId ?? null;
    },
    mapProductoContratado(producto) {
      const productosContratadosId = this.getProductoContratadoId(producto);
      const ubicId = this.getProductoUbicId(producto);

      return {
        ...producto,
        productoLocalId:
          productosContratadosId || `new-${Math.random().toString(36)}`,
        productosContratadosId,
        codigo: producto.codigo || producto.Codigo || "",
        guid: producto.guid || producto.Guid || "",
        implementado: (producto.implementado ?? producto.Implementado) === true,
        ubic_id: ubicId,
      };
    },
    filterSitios(value, search, item) {
      if (!search) return true;

      const text = [
        item.sistemaNombre,
        item.sitioNombre,
        item.descripcion,
        item.rutaDestino,
        item.carpetaBackup,
        item.nombreSitioIIS,
        item.nombrePoolIIS,
        item.puertoIIS,
        item.cadenaConexion,
        item.habilitado ? "habilitado activo si" : "deshabilitado inactivo no",
      ]
        .filter((x) => x !== null && x !== undefined)
        .join(" ")
        .toString()
        .toLowerCase();

      return text.includes(search.toString().toLowerCase());
    },
    escapeRegExp(value) {
      return value.toString().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
    escapeHtml(value) {
      return value
        .toString()
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    highlightSitioText(value) {
      const text = this.escapeHtml(value ?? "");
      const search = (this.searchSitios || "").toString().trim();

      if (!search) return text;

      const pattern = new RegExp(`(${this.escapeRegExp(search)})`, "gi");
      return text.replace(pattern, '<mark class="sitio-search-hit">$1</mark>');
    },
    getSitioDetailFields(item) {
      return [
        { label: "Ruta destino", value: item.rutaDestino },
        { label: "Carpeta backup", value: item.carpetaBackup },
        { label: "Sitio IIS", value: item.nombreSitioIIS },
        { label: "Pool IIS", value: item.nombrePoolIIS },
        { label: "Puerto IIS", value: item.puertoIIS },
        {
          label: "Cadena conexión",
          value: item.cadenaConexion,
          sensitive: true,
        },
      ].filter(
        (field) =>
          field.value !== null &&
          field.value !== undefined &&
          field.value.toString().trim() !== ""
      );
    },
    getMaskedValue(value) {
      if (!value) return "";
      return "•".repeat(Math.min(value.toString().length, 64));
    },
    getSitioVisibilityKey(item) {
      return item.sitioLocalId || item.sitioSistemaClienteId || item;
    },
    isSitioCadenaVisible(item) {
      return this.visibleCadenaConexionSitios.includes(
        this.getSitioVisibilityKey(item)
      );
    },
    toggleSitioCadenaVisible(item) {
      if (!this.canSeeSitioConnectionString) return;

      const key = this.getSitioVisibilityKey(item);

      if (this.visibleCadenaConexionSitios.includes(key)) {
        this.visibleCadenaConexionSitios =
          this.visibleCadenaConexionSitios.filter((x) => x !== key);
        return;
      }

      this.visibleCadenaConexionSitios = [
        ...this.visibleCadenaConexionSitios,
        key,
      ];
    },
    toggleSitioExpanded(item) {
      if (this.expandedSitios.includes(item)) {
        this.expandedSitios = this.expandedSitios.filter((x) => x !== item);
        this.visibleCadenaConexionSitios =
          this.visibleCadenaConexionSitios.filter(
            (x) => x !== this.getSitioVisibilityKey(item)
          );
        return;
      }

      this.expandedSitios = [item];
    },
    getSitioRowClass(item) {
      return this.expandedSitios.includes(item) ? "sitio-row-expanded" : "";
    },
    getTipoDespliegueCodigo(item) {
      const sitioSistemaId = item?.sitioToEdit?.id || item?.sitioSistemaId;
      const sitioCatalogo = this.sitiosSistema.find(
        (sitio) => sitio.id === sitioSistemaId
      );

      return (
        item?.sitioToEdit?.tipoDespliegueCodigo ||
        item?.tipoDespliegueCodigo ||
        sitioCatalogo?.tipoDespliegueCodigo ||
        ""
      )
        .trim()
        .toUpperCase();
    },
    isSitioSql(item) {
      const tipoDespliegueCodigo = this.getTipoDespliegueCodigo(item);
      if (tipoDespliegueCodigo)
        return tipoDespliegueCodigo === "SQL_SCRIPTS";

      const sitioNombre = item?.sitioToEdit?.value || item?.sitioNombre || "";
      return sitioNombre.trim().toUpperCase().includes("SQL");
    },
    isSitioIis(item) {
      const tipoDespliegueCodigo = this.getTipoDespliegueCodigo(item);
      return (
        tipoDespliegueCodigo === "IIS_SITE" ||
        (!tipoDespliegueCodigo && !this.isSitioSql(item))
      );
    },
    isSitioApplication(item) {
      const tipoDespliegueCodigo = this.getTipoDespliegueCodigo(item);
      return (
        ["IIS_SITE", "DESKTOP_FILES"].includes(tipoDespliegueCodigo) ||
        (!tipoDespliegueCodigo && !this.isSitioSql(item))
      );
    },
    async switchTab(num) {
      switch (num) {
        case 1:
          this.tabOptions.tabName = "DATOS GENERALES";
          this.tabOptions.tabId = 1;
          break;
        case 2:
          this.tabOptions.tabName = "CONEXIÓN";
          this.tabOptions.tabId = 2;
          break;
        case 3:
          this.tabOptions.tabName = "CONFIGURACIÓN";
          this.tabOptions.tabId = 3;
          break;
        case 4:
          this.tabOptions.tabName = "CONTACTOS";
          this.tabOptions.tabId = 4;
          break;
        case 5:
          this.tabOptions.tabName = "VERSIONES";
          this.tabOptions.tabId = 5;
          break;
        case 6:
          this.tabOptions.tabName = "NOTAS";
          this.tabOptions.tabId = 6;
          break;
        case 7:
          this.tabOptions.tabName = "OTROS DATOS";
          this.tabOptions.tabId = 7;
          break;
        case 8:
          this.tabOptions.tabName = "PRODUCTOS";
          this.tabOptions.tabId = 8;
          break;
        default:
          break;
      }
    },
    async setPermisosUsuariosAvanzados() {
      await this.$store.dispatch(
        "user/updateFrequencyByOptionCode",
        enumsAdmin.adminSistema.permissions.USUARIOS_AVANZADOS
      );
      this.allowedActionsUsuariosAvanzados = JSON.parse(
        localStorage.getItem("allowedActions")
      );
      this.allowedActionsUsuariosAvanzados?.forEach((x) => {
        switch (x.optionCode) {
          case enumsAdmin.adminSistema.permissions.VER_USER_AVANZADO:
            this.canSeeUsuarioAvanzado = true;
            break;
          default:
            break;
        }
      });
    },
    async getVersiones() {
      this.loadingVersiones = true;
      const params = {
        clienteId: this.clientId,
        sistemaId: this.sistemaSelected == null ? 0 : this.sistemaSelected.id,
      };
      try {
        const res = await this.getVersionesBySistema(params);
        this.itemsVersiones = res;
      } catch (error) {
        console.error(error);
      }
      this.loadingVersiones = false;
    },
    setPermisos() {
      this.permisoAvanzado =
        this.$route.params.permisos?.canAccesoAvanzados || false;
      if (this.permisoAvanzado) {
        this.setPermisosUsuariosAvanzados();
      }
    },
    async setDatosCliente() {
      this.loadingVersiones = true;
      try {
        const res = await this.getAllClientData(
          this.clientId
        );
        this.provinciaSelected = res.provId
          ? this.provincias.find((x) => x.id === res.provId)?.id
          : null;
        this.itemsSitios = res.infoSitios;
        this.itemsSitios.map((el) => {
          el.sitioLocalId =
            el.sitioLocalId ||
            `sitio-${el.sitioSistemaClienteId || Date.now()}-${Math.random()
              .toString(36)
              .slice(2)}`;
          el.itemsSitiosBySistema = this.sitiosSistema.filter(
            (x) => x.sistema == el.sistemaId
          );
        });
        this.codigoEquipo = res.codigoEquipo;
        this.clienteNombre = res.clienteNombre;
        this.clientId = this.clientId || res.clienteId;
        this.razonSocial = res.razonSocial;
        this.observaciones = res.observaciones;
        this.licenciaPerpetua = res.licenciaPerpetua;
        this.soporte = res.soporte;
        this.itemsServidores = res.servidores;
        this.itemsConexiones = res.conexiones;
        this.obvservaciones = res.obvservaciones;
        this.itemsVersiones = res.version;
        this.itemsContacto = res.contacto;
        this.itemsDatosAcceso = res.datosAcceso;
        this.itemsNotas = res.notas;
        await this.loadProductos();
        this.sinSoporte = res.sinSoporte;
        this.rutaDescargaPaquetes = res.rutaDescargaPaquetes || "";
        this.licenciaPerpetua = res.licenciaPerpetua;
        this.otrosDatos = res.otrosDatos;
        this.equipoSoporteSelected = res.codigoEquipo;
        this.fechaLicencia = this.parseDateToIso(res.fechaLicenciaToShow);
        this.fechaLicenciaSelected = this.formatDate(this.fechaLicencia);
        if (res.fechaBaja != null) {
          this.fechaBaja = this.parseDateToIso(res.fechaBaja);
          this.fechaBajaSelected = this.formatDate(this.fechaBaja);
        } else {
          this.fechaBaja = null;
          this.fechaBajaSelected = null;
        }
        this.getEstadoCliente();
      } catch (error) {
        console.error(error);
      }
      this.loadingVersiones = false;
      this.loadingView = false;
      this.isLoadingDatosAcceso = false;
      this.isLoadingConexiones = false;
      this.isLoadingContactos = false;
      this.isLoadingProductos = false;
    },
    async loadProductos() {
      if (!this.clientId) return;

      this.isLoadingProductos = true;
      try {
        const productos = await this.getProductosContratados(this.clientId);
        this.itemsProductos = productos.map((x) =>
          this.mapProductoContratado(x)
        );
      } catch (error) {
        console.error(error);
      }
      this.isLoadingProductos = false;
    },
    getEstadoCliente() {
      if (this.fechaBaja != null) this.estado = "Estado: De baja";
      else {
        if (this.sinSoporte) this.estado = "Estado: Sin soporte";
        else this.estado = "Estado: Activo";
      }
    },
    getEstadoColor(estado) {
      switch (estado) {
        case "Estado: Activo":
          return "green";
        case "Estado: Sin soporte":
          return "orange";
        case "Estado: De baja":
          return "red";
        default:
          return "grey";
      }
    },
    editContacto(item) {
      this.contactoId = item.contactoId;
      this.openEditContactos = true;
    },
    async closeContactos(reload) {
      if (reload) this.isLoadingContactos = true;
      this.openEditContactos = false;
    },
    verDatosAcceso(item) {
      this.datosAccesoToView = {
        datosTexto: item.datosTexto,
        habilitado: item.habilitado
      };
      this.openVerDatosAcceso = true;
    },
    openActualizacionVersion(item) {
      this.actualizacionVersionItem = {
        clienteId: item.clienteId || this.clientId,
        versionId: item.versionId,
      };
      this.openActualizacionModal = true;
    },
    closeVerDatosAcceso() {
      this.openVerDatosAcceso = false;
    },
    editConexion(item) {
      this.itemConexion = item;
      this.openEditDatoConexion = true;
    },
    closeConexiones(reload) {
      if (reload) this.isLoadingConexiones = true;
      this.openEditDatoConexion = false;
    },
    async setSelects() {
      this.equiposSoporte = await this.getEquipos();
      this.provincias = await this.getProvincias();
      const sitios = await this.sitiosSistemasTaxonomy();
      this.sitiosSistema = sitios;
      this.canViewActualizacionesClientes =
        await this.puedeVerActualizacionesClientes();
      if (this.canViewActualizacionesClientes) {
        this.headersVersiones.push({
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "end",
        });
      }
      if (this.clientId) await this.loadUsuarios();
    },
    async loadUsuarios() {
      const response = await this.getUsers(
        this.clientId
      );
      this.itemsUsuariosAvanzados = response.usuariosAvanzados;
      this.itemsUsuariosBasicos = response.usuariosBasicos;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateToIso(date) {
      if (!date) return null;
      if (date.length === 10) {
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
  },
};
</script>

<style>
.label {
  opacity: 0.7;
}
.center-input >>> input {
  text-align: center;
}
.col-producto-codigo {
  width: 28% !important;
}
.col-producto-guid {
  width: 42% !important;
  min-width: 430px !important;
}
.col-producto-activo {
  width: 120px !important;
  min-width: 120px !important;
}
.col-producto-ubicacion {
  width: 100px !important;
  min-width: 100px !important;
}
.producto-guid-cell {
  min-width: 430px;
}
.producto-guid-text {
  display: block;
  font-size: 0.9rem;
  line-height: 1.4;
  overflow-wrap: anywhere;
}
.producto-switch-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.producto-switch-cell .v-input {
  flex: 0 0 auto;
}
.sitios-web-table .v-data-table__wrapper {
  overflow-x: auto;
}
.sitios-web-table tbody tr {
  cursor: pointer;
}
.sitios-web-table tbody tr.sitio-row-expanded {
  background-color: #eef7fb;
  box-shadow: inset 3px 0 0 #0f5a78;
}
.sitios-web-table tbody tr.sitio-row-expanded + tr {
  background-color: #fff;
}
.sitios-table-toolbar {
  padding: 14px 16px 8px 16px;
}
.sitios-table-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.sitios-filters {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 10px;
}
.sitios-search {
  flex: 1 1 260px;
  max-width: 360px;
}
.sitios-system-filter {
  flex: 0 1 260px;
  max-width: 280px;
}
.sitio-main-cell {
  display: flex;
  flex-direction: column;
  min-width: 180px;
}
.sitio-main-text {
  font-weight: 600;
}
.sitio-secondary-text {
  color: rgba(0, 0, 0, 0.55);
  font-size: 0.82rem;
  line-height: 1.2;
  margin-top: 2px;
}
.sitio-status-switch {
  display: flex;
  justify-content: center;
}
.sitio-status-switch .v-input {
  flex: 0 0 auto;
}
.sitio-detail-row {
  background-color: #fff;
  cursor: default;
  padding: 0 !important;
}
.sitio-detail-table-wrap {
  margin: 0 8px 12px 18px;
  max-width: calc(100% - 26px);
  overflow-x: auto;
}
.sitio-detail-table {
  background-color: #fff;
  border-collapse: collapse;
  color: rgba(0, 0, 0, 0.78);
  min-width: 100%;
  table-layout: auto;
}
.sitio-detail-table th {
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 7px 14px;
  text-align: left;
  white-space: nowrap;
}
.sitio-detail-table td {
  font-size: 0.84rem;
  line-height: 1.35;
  max-width: 360px;
  overflow-wrap: anywhere;
  padding: 8px 14px 9px;
  vertical-align: top;
}
.sitio-sensitive-value {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  justify-content: flex-start;
  max-width: 100%;
  min-width: 0;
}
.sitio-sensitive-value span {
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sitio-sensitive-value .v-icon {
  flex: 0 0 auto;
}
.sitio-detail-empty {
  color: rgba(0, 0, 0, 0.55);
  font-style: italic;
}
.sitio-search-hit {
  background-color: #fff176;
  border-radius: 2px;
  color: inherit;
  padding: 0 1px;
}
</style>
